import { Injectable } from '@angular/core';
import { PreferencesService } from 'src/app/project/modules/preferences/preferences-service/preferences.service';
import { TWorkspacePreferences } from 'src/app/project/modules/preferences/preferences.model';
import { TSectionVisibilitySettings } from './export-body.model';
import { EExportFormat } from './utils/export-page-format-enum';

type TPreferencesRequest = {
  workspaceId?: string;
  exportType: string;
  sectionsVisibilitySettings: TSectionVisibilitySettings;
  format?: EExportFormat;
};

@Injectable({
  providedIn: 'root',
})
export class PointExportPreferencesService {
  constructor(private preferencesService: PreferencesService) {}

  updatePreferences({
    workspaceId,
    exportType,
    sectionsVisibilitySettings,
    format = null,
  }: TPreferencesRequest): void {
    const preferences: TWorkspacePreferences = {
      exports: {
        [exportType]: sectionsVisibilitySettings,
      },
    };

    if (format) {
      preferences.exports[exportType].pageFormat = format;
    }

    this.preferencesService.updateExportPreferences(preferences, workspaceId);
  }

  updateOverviewPreferences({
    exportType,
    sectionsVisibilitySettings,
    format = null,
  }: TPreferencesRequest): void {
    const preferences = this.preferencesService.getPreferences();

    preferences.overviewExports[exportType] = sectionsVisibilitySettings;

    if (format) {
      preferences.overviewExports[exportType].pageFormat = format;
    }

    this.preferencesService.updatePreferences(preferences).subscribe();
  }
}
